module.exports = __webpack_public_path__ + "static/media/cart_white.e8d224b0.svg";